
import { getAreaList, getPersonalInfo, updatePersonalInfo, updatePassWord, getNationInfo } from '@/api/baseInfo'

export default {
  state: {
    groupList: [],
    baseProjectList: [],
    politicalList: [],
    stationList: [],
    roleList: [],
    workTypeList: [],
    selectedDept: {},
    deptList: [],
    titleList: [],
    educationList: [],
    nationList: [],
    areaList: [],
    // 无法预览文件类型
    noReviewList: ['csv', 'wps', 'avi', 'rmvb', 'rm', 'flv', 'wmv', 'asf']
  },
  getters: {
    groupList: state => state.groupList,
    baseProjectList: state => state.baseProjectList,
    politicalList: state => state.politicalList,
    stationList: state => state.stationList,
    roleList: state => state.roleList,
    workTypeList: state => state.workTypeList,
    selectedDept: state => state.selectedDept,
    deptList: state => state.deptList,
    titleList: state => state.titleList,
    educationList: state => state.educationList,
    nationList: state => state.nationList,
    areaList: state => state.areaList,
    // 判断文件是否可预览
    isReview: state => (filePath) => {
      const isReview = state.noReviewList.indexOf(filePath.split('.')[1].toLowerCase())
      if (isReview === -1) {
        return true
      } else {
        return false
      }
    }
  },
  mutations: {
    groupList (state, data) {
      state.groupList = data
    },
    baseProjectList (state, data) {
      state.baseProjectList = data
    },
    politicalList (state, data) {
      state.politicalList = data
    },
    stationList (state, data) {
      state.stationList = data
    },
    roleList (state, data) {
      state.roleList = data
    },
    workTypeList (state, data) {
      state.workTypeList = data
    },
    selectedDept (state, data) {
      state.selectedDept = data
    },
    deptList (state, data) {
      state.deptList = data
    },
    titleList (state, data) {
      state.titleList = data
    },
    educationList (state, data) {
      state.educationList = data
    },
    nationList (state, data) {
      state.nationList = data
    },
    areaList (state, data) {
      state.areaList = data
    }
    // isReview (state, filePath) {
    //   const isReview = state.noReviewList.indexOf(filePath.split('.')[1].toLowerCase())
    //   console.log(state.noReviewList, isReview)
    //   if (isReview === -1) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  actions: {
    handleGroupList (groupList, data) {
      groupList.commit('groupList', data)
    },
    handleBaseProjectList (baseProjectList, data) {
      baseProjectList.commit('baseProjectList', data)
    },
    handlePoliticalList (politicalList, data) {
      politicalList.commit('politicalList', data)
    },
    handleStationList (stationList, data) {
      stationList.commit('stationList', data)
    },
    handleRoleList (roleList, data) {
      roleList.commit('roleList', data)
    },
    handleWorkTypeList (workTypeList, data) {
      workTypeList.commit('workTypeList', data)
    },
    handleSelectedDept (selectedDept, data) {
      selectedDept.commit('selectedDept', data)
    },
    handleDeptList (deptList, data) {
      deptList.commit('deptList', data)
    },
    handleTitleList (titleList, data) {
      titleList.commit('titleList', data)
    },
    handleEducationList (educationList, data) {
      educationList.commit('educationList', data)
    },
    handleNationList (nationList, data) {
      nationList.commit('nationList', data)
    },
    handleAreaList (areaList, data) {
      areaList.commit('areaList', data)
    },
    // handleGetAreaList ({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getAreaList().then(response => {
    //       const result = response.data
    //       resolve(result)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // handleGetNationList ({ commit }, params) {
    //   return new Promise((resolve, reject) => {
    //     getNationInfo(params).then(response => {
    //       const result = response
    //       resolve(result)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    handleGetPersonalInfo ({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPersonalInfo(params).then(response => {
          const result = response.data
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    handleUpdatePersonalInfo ({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePersonalInfo(params).then(response => {
          const result = response
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    handleUpdatePassWord ({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePassWord(params).then(response => {
          const result = response
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    }
    // handleProjectList ({ commit }, params) {
    //   return new Promise((resolve, reject) => {
    //     getBaseProjectInfo(params).then(response => {
    //       const result = response
    //       resolve(result)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // }

  }
}
